import React, { useEffect, useRef, useState } from 'react';
import { Form } from 'react-bootstrap';
import { useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { verifyOtp } from '../../../redux/slice/authSlice.js';
import { resendOtp } from '../../../redux/slice/resendOtpSlice.js';
import { OtpSchema } from './ValidationSchema.js';
import addUpdateHandlers from '../../../utils/addUpdateHandlers.js';
import OtpInput from '../../input_fields/OtpInput.jsx';
import SaveButton from '../../buttons/SaveButton.jsx';
import { otpTodo } from '../../../redux/slice/otp.js';
import { signupotpTodo } from '../../../redux/slice/SignupOtpVerify.js';
import { signUpTodo } from '../../../redux/slice/signup.js';
import { updateCookiesTodo } from '../../../redux/slice/UpdateCookies.js';
import { toast } from 'react-toastify';

const OtpVerification = () => {

  const [spinner, setSpinner] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [resendCounter, setResendCounter] = useState(0); // seconds remaining
  const resendIntervalRef = useRef(null);
  const { state } = useLocation();

  // const location = useLocation();

  const from = state?.from || ""
  const signupData = state?.signupData

  const initialValues = {
    email: state?.email || "",
    otp: ""
  };

  const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
    initialValues: initialValues,
    validationSchema: OtpSchema,

    onSubmit: (values, action) => {
      setSpinner(true);
      const otpAction = from === '/signup' ? signupotpTodo : otpTodo;
      dispatch(otpAction(values)).then((res) => otp_verify_res(res.payload));
    }
  });

  const saveUserToLocalStorage = (user) => {
    localStorage.setItem('id', user?.id)
    localStorage.setItem('name', user?.name)
    localStorage.setItem('email', user?.email)
    localStorage.setItem('user_verified', user?.user_verified)
    localStorage.setItem('token', user?.Token)
    localStorage.setItem('user_name', user?.user_name)
    localStorage.setItem('profile_url', user?.profile_url)
    localStorage.setItem('profile_photo', user?.profile_photo)
    localStorage.setItem('biolink_status', user?.biolink_status)
    localStorage.setItem('biolink_expire_date', user?.biolink_expire_date)
    localStorage.setItem('city_id', user?.city_id)
    localStorage.setItem('city_name', user?.city_name)
    localStorage.setItem('company_name', user?.company_name)
    localStorage.setItem('address', user?.address)
    localStorage.setItem('gstnumber', user?.gstnumber)
  }

  const handleSignupAfterOtp = () => {
    dispatch(signUpTodo({ values: signupData })).then((res) => {
      const payload = res?.payload;
      if (payload?.status == 200 || payload?.status == 201) {
        dispatch(updateCookiesTodo())
        saveUserToLocalStorage(payload?.data?.data?.[0])
        toast.success(payload?.data?.message, { position: "bottom-right" })
        setSpinner(false)
        setTimeout(() => {
          navigate('/dashboard');
        }, 1500);
      } else if (payload?.status == 400) {
        setSpinner(false)
        toast.error(payload?.data?.message, { position: "bottom-right" })
      } else if (payload?.status == 500) {
        setSpinner(false)
        toast.error("Server error!!..", { position: "bottom-right" })
      } else {
        setSpinner(false)
        toast.error("Something went wrong!!..", { position: "bottom-right" })
      }
    });
  }

  const otp_verify_res = (res) => {
    if (res?.status == 200 || res?.status == 201) {
      // Signup flow: create account only after OTP success
      if (from === '/signup' && signupData) {
        handleSignupAfterOtp();
        return;
      }

      if (from === '/forgot-password') {
        // Do nothing if from forgot-password
      } else {
        // Login (and other non-signup) OTP success
        saveUserToLocalStorage(res?.data?.data[0])
      }
      toast.success(res?.data?.message, { position: "bottom-right" })
      setSpinner(false)
      setTimeout(() => {
        if (from === '/forgot-password') {
          navigate('/reset-password', { state: { email: res?.data?.data?.[0]?.email } });
        } else {
          navigate('/dashboard');
        }
      }, 1500);
    } else if (res?.status == 400) {
      setSpinner(false)
      toast.error(res?.data?.message, { position: "bottom-right" })
    } else if (res?.status == 500) {
      setSpinner(false)
      toast.error("Server error!!..", { position: "bottom-right" })
    } else {
      setSpinner(false)
      toast.error("Something went wrong!!..", { position: "bottom-right" })
    }
  }

  useEffect(() => {
    setResendCounter(30);
    return () => {
      if (resendIntervalRef.current) {
        clearInterval(resendIntervalRef.current);
      }
    };
  }, []);

  // effect to tick the counter
  useEffect(() => {
    if (resendCounter > 0 && !resendIntervalRef.current) {
      resendIntervalRef.current = setInterval(() => {
        setResendCounter(prev => {
          if (prev <= 1) {
            clearInterval(resendIntervalRef.current);
            resendIntervalRef.current = null;
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
  }, [resendCounter]);

  return (
    <>
      <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
        {/* <div className="">
          <div className="signup-page mt-5">
            <div className="signup-form-container"> */}
        <h3 className="text-center mb-4 biolink-title-gradient">Verify Your Account</h3>
        <div className="text-center mb-4">
          <p className="text-muted">We've sent a 6-digit verification code to</p>
          <p className="fw-bold">{state?.email || ""}</p>
        </div>

        <div className="mb-4">
          <OtpInput
            label_name={"Enter 6-digit OTP"}
            name='otp'
            value={values.otp || ''}
            onChange={(value) => setFieldValue('otp', value)}
            onBlur={handleBlur}
            error={errors.otp && touched.otp ? errors.otp : null}
          />
        </div>

        <div className="text-center">
          <SaveButton
            spinner={spinner}
            button_name={'Verify & Continue'}
            className="btn-primary btn-lg"
          />
        </div>

        <div className="text-center mt-4">
          <p className="mb-0">
            Didn't receive the code ?
            <button
              type="button"
              className=" ms-2 text-primary p-0"
              disabled={resendCounter > 0}
              onClick={() => {
                // Start the 30s countdown immediately
                setResendCounter(30);

                dispatch(resendOtp({
                  email: state?.email || ""
                })).then((res) => {
                  // use existing handler but also clear timer on failure
                  addUpdateHandlers({
                    res: res.payload,
                    action: null,
                    navigate,
                    success_toast: 'OTP resent successfully',
                    wrong_toast: 'Failed to resend OTP',
                    navigate_route: '',
                    spinner: () => { }
                  });

                  // if resend failed (non-200), stop countdown and re-enable button
                  const status = res?.payload?.status;
                  if (status !== 200 && status !== 201) {
                    // clear countdown
                    if (resendIntervalRef.current) {
                      clearInterval(resendIntervalRef.current);
                      resendIntervalRef.current = null;
                    }
                    setResendCounter(0);
                  }
                }).catch(() => {
                  // in case dispatch itself throws
                  if (resendIntervalRef.current) {
                    clearInterval(resendIntervalRef.current);
                    resendIntervalRef.current = null;
                  }
                  setResendCounter(0);
                });
              }}
            >
              {resendCounter > 0 ? `Resend OTP after (${resendCounter}s)` : 'Resend OTP'}
            </button>
            {/* <button
                          type="button"
                          className="btn btn-link p-0"
                          onClick={() => {
                            dispatch(resendOtp({
                              email: email || ""
                            })).then((res) => addUpdateHandlers({
                              res: res.payload,
                              action: null,
                              navigate,
                              success_toast: 'OTP resent successfully',
                              wrong_toast: 'Failed to resend OTP',
                              navigate_route: '',
                              spinner: () => { }
                            }));
                          }}
                        >Resend OTP</button> */}
          </p>
        </div>
        {/* </div>

          </div>
        </div> */}
      </Form>
    </>
  );
};

export default OtpVerification;